import LcInput from './Input';
export default LcInput;
